export const TIME_RANGE_DATE_VALUE_FORMAT = 'HH:mm:ss';
